import { FormlyFieldConfig } from '@ngx-formly/core';

export class ApplicationFormSchema {
  isReadOnlySchema: boolean;
  name: string;
  schema: FormlyFieldConfig[];
  version: number;
}
